import { Link } from "react-router-dom";
import type { Post } from "@/types/content";

interface TopicBannerProps {
  posts: Post[];
}

export default function TopicBanner({ posts }: TopicBannerProps) {
  const picks = posts.filter((p) => p.categorySlug === "picks").slice(0, 3);

  return (
    <section aria-labelledby="topic-title" className="w-full px-4 md:px-6 pb-12 md:pb-16">
      <div className="relative rounded-lg overflow-hidden bg-foreground-950">
        <div className="absolute inset-0 opacity-25">
          <img
            src="https://readdy.ai/api/search-image?query=Abstract%20editorial%20illustration%20of%20stacked%20newspaper%20pages%20and%20a%20highlighter%20pen%2C%20warm%20coral%20red%20and%20amber%20accents%2C%20minimal%20flat%20design%2C%20deep%20charcoal%20background%2C%20magazine%20spread%20composition%2C%20soft%20grain%20texture&width=1400&height=700&seq=gg-topic-01&orientation=landscape"
            alt="本周专题线索精选的抽象背景插画"
            title="本周专题 - 网曝吃瓜"
            className="w-full h-full object-cover object-top"
          />
        </div>

        <div className="relative grid grid-cols-1 lg:grid-cols-12 gap-8 p-6 md:p-10">
          <div className="lg:col-span-5">
            <p className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-500 text-foreground-950 text-xs font-medium">
              <i className="ri-calendar-check-line" aria-hidden="true" />
              本周专题 · 第 38 期
            </p>
            <h2 id="topic-title" className="mt-4 text-2xl md:text-3xl font-bold text-background-50 leading-snug">
              那些没有上热搜，却值得被看见的线索
            </h2>
            <p className="mt-4 text-sm md:text-base text-background-300 leading-relaxed">
              编辑部从本周两百多份来稿里挑出信息密度最高的一批，补上背景、标注来源，做成可以直接阅读的时间线。
              它们大多没有冲突感，但更接近真实生活。
            </p>
            <div className="mt-6 flex flex-wrap gap-3">
              <Link
                to="/category/picks"
                className="inline-flex items-center gap-2 px-4 py-2.5 rounded-md bg-accent-500 text-foreground-950 text-sm whitespace-nowrap hover:bg-accent-400 transition-colors"
              >
                查看本期专题
                <i className="ri-arrow-right-line" aria-hidden="true" />
              </Link>
              <Link
                to="/submit"
                className="inline-flex items-center gap-2 px-4 py-2.5 rounded-md border border-background-50/30 text-background-100 text-sm whitespace-nowrap hover:bg-background-50/10 transition-colors"
              >
                投稿我的线索
              </Link>
            </div>
          </div>

          <div className="lg:col-span-7 flex flex-col gap-3">
            {picks.map((post, idx) => (
              <Link
                key={post.id}
                to={`/post/${post.slug}`}
                className="group flex items-start gap-4 p-4 rounded-lg bg-background-50/5 border border-background-50/10 hover:bg-background-50/10 transition-colors"
              >
                <span className="font-brand text-3xl text-accent-400 leading-none shrink-0 w-8">
                  {idx + 1}
                </span>
                <span className="min-w-0 flex-1">
                  <span className="block text-sm md:text-base font-bold text-background-100 leading-snug group-hover:text-accent-300 transition-colors line-clamp-2">
                    {post.title}
                  </span>
                  <span className="mt-1.5 block text-xs text-background-400 line-clamp-1">{post.excerpt}</span>
                </span>
                <i
                  className="ri-arrow-right-s-line text-background-400 group-hover:text-accent-400 transition-colors shrink-0 mt-1"
                  aria-hidden="true"
                />
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}